import { useLang } from "@/i18n/LangContext";
import { useContent } from "@/context/SiteContext";
import { Container, Eyebrow, LLink, ArrowLink } from "@/components/common";
import { Reveal, LineReveal, Stagger, Item } from "@/components/motion/Reveal";

const IMG_A = "/images/exterior/fachada.webp";

export function Presentation() {
  const { t, lang } = useLang();
  const c = useContent();
  return (
    <section id="presentation" data-testid="home-presentation" className="bg-sand py-20 md:py-32">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <Reveal><Eyebrow className="mb-6">{t.home.presEyebrow}</Eyebrow></Reveal>
            <LineReveal
              as="h2"
              lines={t.pages.homeHeadings.presentation}
              className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-charcoal"
            />
            <Reveal delay={0.2}>
              <p className="mt-8 max-w-md text-base md:text-lg leading-relaxed text-charcoal/70">{c("pres_text", lang)}</p>
              <LLink to="rooms" data-testid="presentation-cta" className="mt-8 inline-block">
                <ArrowLink>{c("pres_cta", lang, t.common.seeMore)}</ArrowLink>
              </LLink>
            </Reveal>
            <Stagger className="mt-14 grid grid-cols-2 gap-x-6 gap-y-8 border-t border-line pt-8">
              {t.home.stats.map((s) => (
                <Item key={s.n + s.l}>
                  <p className="font-serif text-4xl md:text-5xl tracking-tight text-charcoal">{s.n}</p>
                  <p className="mt-1 text-xs md:text-sm text-charcoal/55">{s.l}</p>
                </Item>
              ))}
            </Stagger>
          </div>

          <div className="lg:col-span-7">
            <Reveal className="img-zoom aspect-[4/3] lg:aspect-[5/4]">
              <img src={IMG_A} alt="Fachada y entrada principal del Hotel Ciutat Martorell" loading="lazy" className="h-full w-full object-cover" />
            </Reveal>
          </div>
        </div>
      </Container>
    </section>
  );
}
